import { Device } from '@twilio/voice-sdk';

let device = null;
let activeCall = null;

export async function initDevice(token) {
  device = new Device(token, {
    logLevel: 'info',
    codecPreferences: ['opus', 'pcmu'],
  });

  device.on('registered', () => console.log('✅ Twilio Device registered'));
  device.on('error', (err) => console.error('❌ Device error:', err));
  device.on('incoming', (call) => {
    console.log('📞 Incoming call...');
    activeCall = call;
    call.accept();
  });

  await device.register();
}

export async function makeCall(params = {}) {
  if (!device) throw new Error('Device not initialized');

  console.log('📤 Dialing:', params);
  activeCall = await device.connect({ params });

  activeCall.on('disconnect', () => {
    console.log('📴 Call disconnected');
    activeCall = null;
  });

  activeCall.on('error', (err) => {
    console.error('❌ Call error:', err);
  });

  return activeCall;
}

export async function endAllCalls() {
  if (activeCall) {
    console.log('👋 Ending current call...');
    activeCall.disconnect();
    activeCall = null;
  }
}

export async function cleanupDevice() {
  if (device) {
    await device.destroy();
    device = null;
    activeCall = null;
    console.log('🧹 Device cleaned up');
  }
}
